import type { AppErrorDetails } from './appErrorTypes';
import { APP_ERROR_STORAGE_KEY } from './appErrorTypes';

export function persistAppError(error: AppErrorDetails): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(APP_ERROR_STORAGE_KEY, JSON.stringify(error));
  } catch {
    // ignore quota errors
  }
}

export function consumePersistedAppError(): AppErrorDetails | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(APP_ERROR_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    sessionStorage.removeItem(APP_ERROR_STORAGE_KEY);
    const parsed = JSON.parse(raw) as AppErrorDetails;
    if (parsed && typeof parsed === 'object' && parsed.kind && parsed.message) {
      return parsed;
    }
  } catch {
    // ignore
  }
  return null;
}

export function clearPersistedAppError(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(APP_ERROR_STORAGE_KEY);
  } catch {
    // ignore
  }
}
